import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'my-12 flex justify-center',
    video: 'max-h-[calc(100vh-200px)] w-auto max-sm:h-auto max-sm:w-full'
  }
});
